import React from "react";
import images from "../../Data/images";
import { FaPhoneAlt } from "react-icons/fa";
import {
  FaShieldAlt,
  FaFire,
  FaConciergeBell,
  FaUserTie,
  FaUserShield,
  FaParking,
  FaCamera,
  FaVideo,
  FaClipboardList,
  FaCogs,
  FaHeadset,
  FaMapMarkerAlt,
} from "react-icons/fa";

const servicesList = [
  {
    id: "uniformedsecurity",
    title: "Uniformed Security Guards",
    icon: FaShieldAlt,
  },
  {
    id: "mobilepatrol",
    title: "Mobile Patrol Services",
    icon: FaShieldAlt,
  },
  {
    id: "firewatch",
    title: "Fire Watch Security",
    icon: FaFire,
  },
  {
    id: "conciergesecurity",
    title: "Concierge / Front Desk Security",
    icon: FaConciergeBell,
  },
  {
    id: "executiveelite",
    title: "Executive & Elite Security Services",
    icon: FaUserTie,
  },
  {
    id: "executiveprotection",
    title: "Executive Protection",
    icon: FaUserShield,
  },
  {
    id: "gatehousesecurity",
    title: "Gatehouse Security",
    icon: FaMapMarkerAlt,
  },
  {
    id: "parkingmanagementsolutions",
    title: "Parking Management Solutions",
    icon: FaParking,
  },
  {
    id: "parkingenforcement",
    title: "Parking Enforcement",
    icon: FaParking,
  },
  {
    id: "eventsecurity",
    title: "Event Security",
    icon: FaUserShield,
  },
  {
    id: "camerainstallations",
    title: "Camera Installations",
    icon: FaCamera,
  },
  {
    id: "securitysystems",
    title: "Security Systems & Access Control",
    icon: FaCogs,
  },
  {
    id: "lossprevention",
    title: "Loss Prevention",
    icon: FaClipboardList,
  },
  {
    id: "privateinvestigation",
    title: "Private Investigation Services",
    icon: FaClipboardList,
  },
  {
    id: "processserving",
    title: "Process Serving",
    icon: FaClipboardList,
  },
];

const detailedServices = [
  {
    id: "uniformedsecurity",
    title: "Uniformed Security Guards",
    image: images.service1,
    description:
      "Professional on-site security guards provide visible deterrence, access control, incident response, and safety monitoring for residential, commercial, construction, and industrial environments.",
  },
  {
    id: "mobilepatrol",
    title: "Mobile Patrol Services",
    image: images.s7,
    description:
      "Mobile patrol services provide scheduled and randomized patrols of properties using marked security vehicles, delivering visible deterrence, alarm response, and proactive property monitoring.",
  },
  {
    id: "conciergesecurity",
    title: "Concierge / Front Desk Security",
    image: images.service8,
    description:
      "Concierge security officers provide professional lobby security, visitor management, CCTV monitoring, and resident support while maintaining a welcoming presence in residential and commercial buildings.",
  },
  {
    id: "gatehousesecurity",
    title: "Gatehouse Security",
    image: images.service4,
    description:
      "Gatehouse security officers manage entry points, monitor vehicle access, verify visitors, and maintain controlled property access for industrial sites, residential communities, and logistics facilities.",
  },
  {
    id: "eventsecurity",
    title: "Event Security",
    image: images.service5,
    description:
      "Argus Security provides trained event security personnel to manage access control, crowd flow, perimeter monitoring, and incident response for corporate events, festivals, and private functions.",
  },
  {
    id: "securitysystems",
    title: "Security Systems & Access Control",
    image: images.service6,
    description:
      "Argus installs CCTV surveillance systems, access control technology, and integrated monitoring solutions designed to improve visibility, deter incidents, and protect property.",
  },
  {
    id: "executiveelite",
    title: "Executive & Elite Security Services",
    image: images.service7,
    description:
      "Elite security officers in professional business attire provide discreet protection for luxury environments, executive offices, high-end retail locations, and corporate events.",
  },
  {
    id: "parkingenforcement",
    title: "Parking Enforcement",
    image: images.service13,
    description:
      "Argus Security International provides professional parking enforcement programs designed specifically for private properties residential communities, and office complexes  helping maintain order, improve compliance, and reduce complaints.",
  },
  {
    id: "camerainstallations",
    title: "Camera Installations",
    image: images.service6,
    description:
      "Argus installs professional CCTV camera systems designed to provide high-definition monitoring, remote viewing, evidence documentation, and improved property visibility.",
  },
  {
    id: "parkingmanagementsolutions",
    title: "Parking Management Solutions",
    image: images.service9,
    description:
      "Argus Security International Inc. provides comprehensive parking management solutions designed to improve organization, maximize space utilization, and ensure smooth day-to-day parking operations for residential, commercial, and mixed-use properties.",
  },
  {
    id: "firewatch",
    title: "Fire Watch Security",
    image: images.service11,
    description:
      "Fire watch security personnel conduct continuous patrols to monitor fire hazards and maintain safety when fire protection systems are temporarily out of service.",
  },
  {
    id: "executiveprotection",
    title: "Executive Protection",
    image: images.service7,
    description:
      "Executive protection specialists provide discreet personal security for executives, public figures, and VIP guests while maintaining situational awareness and risk management.",
  },
  {
    id: "lossprevention",
    title: "Loss Prevention",
    image: images.service14,
    description:
      "Argus loss prevention officers help retail businesses detect theft, monitor store activity, and support retail management in maintaining safe shopping environments.",
  },
  {
    id: "privateinvestigation",
    title: "Private Investigation Services",
    image: images.service12,
    description:
      "Argus investigators provide professional investigative services including surveillance investigations, corporate investigations, insurance investigations, and background checks.",
  },
  {
    id: "processserving",
    title: "Process Serving",
    image: images.service15,
    description:
      "Argus provides professional legal document delivery services including court documents, legal notices, landlord notices, and affidavit of service documentation.",
  },
];

// ServiceCard with scroll functionality
const ServiceCard = ({ id, title, icon: Icon }) => {
  const handleClick = () => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div
      onClick={handleClick}
      className="cursor-pointer p-6 bg-white shadow-lg rounded-xl border-2 transition-all transform hover:-translate-y-2 hover:shadow-2xl hover:border-[#c4122f]"
    >
      <div className="text-4xl mb-4 text-center text-[#c4122f]">
        <Icon />
      </div>
      <h3 className="text-2xl font-semibold text-center text-gray-900">
        {title}
      </h3>
    </div>
  );
};

// Main Service Component
const Service = () => {
  return (
    <div className="">
      {/* Header */}
      <div className="bg-[#c4122f] text-white py-16 px-6 md:px-20 flex flex-col md:flex-row justify-between items-center gap-6">
        <div>
          <h1 className="text-4xl font-bold mb-4">Service</h1>
          <p className="text-lg max-w-xl">
            Nationwide High-Quality Security Services
          </p>
        </div>
      </div>

      {/* Breadcrumb and Contact */}
      <div className="flex justify-between items-center py-4 px-6 md:px-20 border-b">
        <span className="text-sm text-gray-500">HOME / SERVICE</span>
        <span className="flex items-center gap-2 text-sm text-gray-700">
          <FaPhoneAlt className="text-[#c4122f]" />
          +1 (416) 477-7692
        </span>
      </div>

      {/* Company Overview */}
      <div className="max-w-5xl mx-auto px-4 py-16 text-center">
        <h2 className="text-2xl md:text-3xl font-bold mb-4">
          We are a high-touch company with a national footprint
        </h2>
        <p className="text-gray-700 max-w-3xl mx-auto">
          Argus Security International Inc. offers professional security
          services to commercial, healthcare/medical, elite residential
          properties, and more...
        </p>
      </div>

      {/* Services Grid */}
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 py-10">
        {servicesList.map((service, index) => (
          <ServiceCard
            key={index}
            id={service.id}
            title={service.title}
            icon={service.icon}
          />
        ))}
      </div>

      {/* Detailed Services Section */}
      <div className="w-full max-w-7xl mx-auto px-4 py-16 grid gap-8 grid-cols-1 md:grid-cols-2">
        {detailedServices.map((service) => (
          <div
            key={service.id}
            id={service.id}
            className="bg-white shadow-md rounded-xl overflow-hidden h-[550px] flex flex-col"
          >
            <img
              src={service.image}
              alt={service.title}
              className="h-[400px] w-full object-cover"
            />
            <div className="p-4 flex flex-col flex-1">
              <h2 className="text-xl font-semibold text-[#c4122f] mb-2">
                {service.title}
              </h2>
              <p className="text-gray-700 overflow-y-auto text-sm flex-1">
                {service.description}
              </p>
              <a
                className="text-sm text-[#c4122f] mt-2"
                href={`/service/${service.id}`}
              >
                Read More
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Service;
